/*global AmCharts, App */

Components.Energy.Engineer.FifteenMax = function (container, loadDataLink) {
    /* private */
    var _chart;
    var zoomOut = function() {
        try {
            _chart.zoomOut();
        } catch (e) {
        }
    };
    var loadDataForChart = function () {
        App.Ui.widgetBlock($("#" + container));
        $.ajax({
            dataType: "json",
            url: loadDataLink,
            complete: function () {
                App.Ui.widgetBlock($("#" + container), "stop");
            },
            success: function (result) {
                if (result.records !== null && result.records.length > 0) {
                    prepareDataForChart(result);
                } else {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                }
            },
            error: function () {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });
    };
    var prepareDataForChart = function (rawData) {
        var dataProvider = [];
        for (var index in rawData.records) {
            var row = rawData.records[index];
            var record = {};
            if (row.value) {
                record.value = Math.round(row.value * 100) / 100;
            }
            record.date = new Date(row.timestamp * 1000);
            dataProvider.push(record);
        }
        if (dataProvider.length === 0) {
            App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
        } else {
            _chart.dataSets[0].dataProvider = dataProvider;
            _chart.validateData();
            setTimeout(zoomOut, 250);
        }
    };
    var createChart = function () {
        var exportSettings = App.Charts.export;
        exportSettings.exportTitles = false;
        _chart = new AmCharts.AmStockChart();
        _chart.colors = [App.Ui.getColors()[6]];
        _chart.language = "cz";
        _chart.pathToImages = "/dist/amcharts/images/";
        _chart.export = exportSettings;
        _chart.dataSets = [
            {
                categoryField: "date",
                fieldMappings: [
                    {fromField: "value", toField: "value"}
                ]
            }
        ];

        var stockPanel = new AmCharts.StockPanel();
        stockPanel.recalculateToPercents = "never";
        stockPanel.usePrefixes = true;
        stockPanel.colors = _chart.colors;
        _chart.addPanel(stockPanel);

        var graph = new AmCharts.StockGraph();
        graph.id = "g1";
        graph.valueField = "value";
        graph.type = "column";
        graph.fillAlphas = 0.9;
        graph.columnWidth = 0.75;
        graph.showBalloon = true;
        graph.balloonText = "[[value]]";
        graph.useDataSetColors = false;
        stockPanel.addStockGraph(graph);

        var panelsSettings = new AmCharts.PanelsSettings();
        panelsSettings.marginLeft = 80;
        _chart.panelsSettings = panelsSettings;

        var valueAxesSettings = new AmCharts.ValueAxesSettings();
        valueAxesSettings.inside = false;
        _chart.valueAxesSettings = valueAxesSettings;

        var categoryAxesSettings = new AmCharts.CategoryAxesSettings();
        categoryAxesSettings.groupToPeriods = ["15mm"];
        categoryAxesSettings.minPeriod = "15mm";
        _chart.categoryAxesSettings = categoryAxesSettings;

        var scrollbarSettings = new AmCharts.ChartScrollbarSettings();
        scrollbarSettings.graph = "g1";
        scrollbarSettings.updateOnReleaseOnly = false;
        _chart.chartScrollbarSettings = scrollbarSettings;

        var cursorSettings = new AmCharts.ChartCursorSettings();
        cursorSettings.categoryBalloonEnabled = true;
        cursorSettings.cursorAlpha = 0.05;
        cursorSettings.fullWidth = true;
        cursorSettings.valueBalloonsEnabled = true;
        cursorSettings.valueLineEnabled = true;
        cursorSettings.valueLineBalloonEnabled = true;
        cursorSettings.valueLineAlpha = 0.5;
        _chart.chartCursorSettings = cursorSettings;

        _chart.write(container);
        loadDataForChart();
    };
    var zoomToHour = function () {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        inactive();
        $("#" + container + "_zoomToHour").addClass("active");
    };
    var zoomToDay = function () {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        inactive();
        $("#" + container + "_zoomToDay").addClass("active");
    };
    var zoomMax = function () {
        zoomOut();
        inactive();
        $("#" + container + "_zoomMax").addClass("active");
    };
    var inactive = function() {
        $("#" + container + "_zoomToHour").removeClass("active");
        $("#" + container + "_zoomToDay").removeClass("active");
        $("#" + container + "_zoomMax").removeClass("active");
    };
    /* public */
    /* construct */
    createChart();
    $("#" + container + "_zoomToHour").click(zoomToHour);
    $("#" + container + "_zoomToDay").click(zoomToDay);
    $("#" + container + "_zoomMax").click(zoomMax);
};
